
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from "../ui/button";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, path) => {
    e.preventDefault();
    
    // Check if it's a hash link (scroll on homepage)
    if (path.startsWith('/#')) {
      const sectionId = path.substring(2); // Remove '/#'
      
      // If already on homepage, just scroll
      if (location.pathname === '/') {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      } else {
        // Navigate to homepage first, then scroll
        navigate('/');
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      }
      window.history.pushState({}, '', path);
    } else {
      // Regular navigation
      navigate(path);
    }
    
    // Close mobile menu
    setIsOpen(false);
  };

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'What We Build', path: '/#what-we-build' },
    { name: 'Industries', path: '/industries' },
    { name: 'How We Work', path: '/#how-we-work' },
    { name: 'Company', path: '/careers' },
  ];

  return (
    <nav className="fixed w-full z-50 top-0 left-0 glass-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => window.location.href='/'}>
            {/* 
                Using the new vedara-logo-final.png
                Maintaining brightness-0 invert to ensure white logo on dark theme
            */}
            <img 
                src="/vedara-logo-final.png" 
                alt="Vedara Logo" 
                className="h-12 w-auto object-contain brightness-0 invert hover:opacity-80 transition-opacity"
            />
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.path}
                  onClick={(e) => handleNavClick(e, link.path)}
                  className={`text-sm font-semibold transition-all duration-300 cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-blue-400'
                      : 'text-gray-300 hover:text-white'
                  }`}
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <div className="hidden md:block">
             <Link to="/contact">
                <Button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded-lg transition-all shadow-lg">
                    Build a Voice Agent →
                </Button>
             </Link>
          </div>

          <div className="-mr-2 flex md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-300 hover:text-white hover:bg-gray-800 focus:outline-none"
            >
              {isOpen ? <X className="block h-6 w-6" /> : <Menu className="block h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-background border-b border-gray-800">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.path}
                onClick={(e) => handleNavClick(e, link.path)}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-800 cursor-pointer"
              >
                {link.name}
              </a>
            ))}
             <Link to="/contact" onClick={() => setIsOpen(false)}>
                <Button className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white">Build a Voice Agent</Button>
             </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
